import { Reveal, SectionHead, Btn } from "../Bits";
import { PROCESS } from "../../lib/site";

const Process = () => (
  <section
    data-testid="home-process"
    className="border-y border-[#111111]/10 bg-[#F5F5F2] py-20 lg:py-32"
  >
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <Reveal>
        <SectionHead
          eyebrow="Process"
          title="From floor plan to finished space"
          copy="Four stages, no guesswork. We plan the surface with you before anything is ordered."
        />
      </Reveal>

      <div className="mt-14 grid gap-px border border-[#111111]/10 bg-[#111111]/10 sm:grid-cols-2 lg:mt-20 lg:grid-cols-4">
        {PROCESS.map((p, i) => (
          <Reveal key={p.step} delay={i * 0.08}>
            <div
              data-testid={`process-step-${p.step}`}
              className="group h-full bg-white p-8 transition-colors duration-500 hover:bg-white lg:p-10"
            >
              <div className="flex items-center gap-4">
                <span className="font-display text-3xl font-bold text-[#0F4C81]">{p.step}</span>
                <span className="h-[1px] flex-1 bg-[#111111]/10 transition-colors duration-500 group-hover:bg-[#0F4C81]" />
              </div>
              <p className="mako-label mt-8 text-[#111111]">{p.title}</p>
              <p className="mt-4 text-sm leading-relaxed text-[#3B3B3B]">{p.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.12}>
        <div className="mt-12">
          <Btn to="/contact" variant="dark" data-testid="process-cta">
            Start your project
          </Btn>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Process;
